import type { Messages } from '@lingui/core'

type Catalog = { messages: Messages }

// Preserve caller order, regardless of asynchronous import completion order.
export const loadCatalogs = async (
  catalogs: Array<Promise<Catalog>>
): Promise<Messages> => {
  const loaded = await Promise.all(catalogs)

  return Object.assign({}, ...loaded.map(({ messages }) => messages))
}

export const loadNamedCatalogs = (
  order: readonly string[],
  loaders: Record<string, () => Promise<Catalog>>
): Promise<Messages> =>
  loadCatalogs(
    order.map((name) => {
      if (!Object.prototype.hasOwnProperty.call(loaders, name)) {
        throw new Error(`Missing catalog loader: ${name}`)
      }

      return loaders[name]()
    })
  )
